export default __webpack_public_path__ + "static/media/image1.2087ac5d.png";